






















































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { Table } from "@/utils/decorator";
import { emptyToLine, splitThousands } from "@/utils/common";
import dayjs from "dayjs";
import ShowSettlement from "@/views/service/components/settlement.vue";
const service = namespace("service");
const finance = namespace("finance");
const base = namespace("base");
const typeMap: any = {
  maintenance: 1,
  wash: 2,
  retail: 3
};
const todayUser = [
  {
    name: "icon-total-money",
    title: window._I18N.t("finance.total-amount-chargeable-account-yuan"),
    tNum: undefined,
    class: "blue"
  },
  {
    name: "icon-order-quantity",
    title: window._I18N.t("finance.charged-order-number-pen"),
    tNum: undefined,
    class: "lime"
  },
  {
    name: "icon-one-month-all",
    title: window._I18N.t("finance.credit-over-one-month"),
    tNum: undefined,
    class: "orange"
  },
  {
    name: "icon-exceed-month",
    title: window._I18N.t("finance.number-orders-over-one-month"),
    tNum: undefined,
    class: "yellow"
  }
];
@Component({
  components: { ShowSettlement }
})
@Table("loadListData")
export default class OnAccountManage extends Vue {
  @finance.Mutation setCurrentTabType;
  @finance.Action queryOnAccountCustomer;
  @finance.Action statisticOnAccount;
  @finance.Action getCustomerUnpaidOrder;
  @finance.Action queryOrderList;
  @finance.Mutation setOnAccountManageRow;
  @finance.State currentTabType;
  //计算属性
  get tabBarData() {
    return [
      { tabName: window._I18N.t("finance.payment-customer"), type: "maintenance" },
      { tabName: window._I18N.t("finance.charge-more-month-order"), type: "wash" }
    ];
  }
  get orderType() {
    return typeMap[this.currentTabType];
  }
  searchForm = {};
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  dayjs = dayjs;
  freshDate: any = undefined;
  todayUser: any = todayUser;
  orderList: any[] = [];
  appointmentDate: any = [];
  onAccountList: any = [];
  seletedStatus: string = "";
  defaultExpend: boolean = false;
  get urlDate() {
    return this.$route.query.date || "";
  }
  created() {
    sessionStorage.setItem("onAccountId", "");
    this.getStatisticOnAccount();
    this.init();
    this.setOnAccountManageRow({});
  }
  mounted() {}
  init() {
    if (this.$route.query.type === "all") {
      this.setCurrentTabType("all");
    }
    // 根据url中时间设置筛选条件并查询
    if (this.urlDate) {
      let year = dayjs().get("year");
      this.appointmentDate = [`${this.urlDate}`, `${this.urlDate}`];
      this.seletedStatus = "2";
      this.defaultExpend = true;
    } else {
      if (this.orderType === 1) {
        this.initQueryOnAccountCustomer();
      } else if (this.orderType === 2) {
        this.loadListData();
      }
    }
  }
  @Table.LoadDataMethod()
  initQueryOnAccountCustomer() {
    return this.queryOnAccountCustomer({ orderItems: [], pageNum: this.mix_pageNum, pageSize: this.mix_pageSize }).then(
      response => {
        this.onAccountList = response.data.list;
        return response;
      }
    );
  }
  handleSwitchStatus(tab) {
    this.setCurrentTabType(tab.type);
    this.mix_pageNum = 1;
    if (this.orderType === 1) {
      this.initQueryOnAccountCustomer();
    } else if (this.orderType === 2) {
      this.loadListData();
    }
  }
  getStatisticOnAccount() {
    this.statisticOnAccount({
      timeout: dayjs()
        .subtract(1, "month")
        .format("YYYYMMDD")
    }).then(data => {
      this.todayUser[0].tNum = data.data.onAccountAmount;
      this.todayUser[1].tNum = data.data.onAccountCount;
      this.todayUser[2].tNum = data.data.timeoutAmount;
      this.todayUser[3].tNum = data.data.timeoutCount;
    });
  }
  @Table.LoadDataMethod()
  loadListData() {
    if (this.orderType === 1) {
      return this.queryOnAccountCustomer({
        orderItems: this.mix_sortParams,
        pageNum: this.mix_pageNum,
        pageSize: this.mix_pageSize
      }).then(response => {
        this.onAccountList = response.data.list;
        return response;
      });
    } else if (this.orderType === 2) {
      if (!this.mix_sortParams[0].item && !this.mix_sortParams[0].type) {
        this.mix_sortParams[0].item = "paidTime";
        this.mix_sortParams[0].type = "asc";
      }
      return this.queryOrderList({
        orderItems: this.mix_sortParams,
        paidTimeEnd: dayjs()
          .subtract(1, "month")
          .format("YYYYMMDD"),
        settlementStatus: "2",
        pageNum: this.mix_pageNum,
        pageSize: this.mix_pageSize
      }).then(data => {
        this.mix_sortParams[0].item = "";
        this.mix_sortParams[0].type = "";
        this.orderList = data.data.list;
        return data;
      });
    }
  }
  handleView(row) {
    let { href } = this.$router.resolve({
      path: `/service/view/${row.orderNo}`
    });
    window.open(href, "_blank");
  }
  async handleSettlement(row) {
    const respons = await this.getCustomerUnpaidOrder({
      customerCode: row.customerCode,
      settlementStatus: 2
    }).then(data => {
      this.$router.push({
        name: "serviceCashier",
        params: {
          id: data.data[0].orderNo,
          onAccountTo: "true",
          row: row
        }
      });
    });
  }
  handleOnAcountDetail(row) {
    sessionStorage.setItem("onAccountId", JSON.stringify(row));
    this.$router.push({
      name: "onAccountDetail",
      params: {
        customerCode: row.customerCode,
        customerName: row.customerName,
        row: row
      }
    });
  }
  // ----------------
}
